import { Result } from 'domain/types';

import CreateDashboardClient from 'use-case/dashboard/create/createDashboardClient';
import CreateDashboardCriteria from 'use-case/dashboard/create/createDashboardCriteria';
import BasicEntity from 'domain/entity/basicEntity';

export type CreateDashboardResult = Result<BasicEntity>;
export type CreateDashboard = (criteria: CreateDashboardCriteria) => Promise<CreateDashboardResult>;

export default (createDashboardClient: CreateDashboardClient): CreateDashboard => (
    criteria: CreateDashboardCriteria
): Promise<CreateDashboardResult> => createDashboardClient(criteria);
